<template>
  <div>
    <div class="goods-list-container">
      <div class="confirm-order">
        <div class="img">
          <img src="../../assets/pc/images/pay/order.png" alt="" />
        </div>
        <div class="step">
          <StepNumber align="right" :current="1" chooseType="confirm">
            <StepCommit :index="1">1.我的购物车</StepCommit>
            <StepCommit :index="2">2.填写核对订单信息</StepCommit>
            <StepCommit :index="3">3.成功提交订单</StepCommit>
          </StepNumber>
        </div>
      </div>
      <div class="main-content">
        <div class="address-form common-padding">
          <div class="title-box common-title">
            <div class="common-red-quote">收货地址</div>
            <div class="add-new-address" @click="goAddAddress">新增地址</div>
          </div>
          <div class="address-list">
            <div class="wrapper" ref="wrapper">
              <ul class="content" ref="addressTab">
                <template v-if="border === 0">
                  <div
                    class="item"
                    v-for="item of address"
                    :key="item.id"
                    :class="isDefault === item.id ? 'active' : ''"
                    @click="changeAddress(item.id)"
                  >
                    <div class="main-name">
                      <img src="/assets/pc/images/pay/location.png" alt="" />
                      <span>{{ item.real_name }}</span>
                      <span>{{ item.province }}</span>
                      <div v-if="item.is_default === 1" class="default">
                        （默认）
                      </div>
                    </div>
                    <div class="main-location">
                      <div class="people-box">
                        <span>{{ item.real_name }}</span>
                        <span>{{ item.phone }}</span>
                      </div>
                      <div class="province">
                        <span>{{ item.province }}</span>
                        <span>{{ item.city }}</span>
                        <span>{{ item.district }}</span>
                      </div>
                      <div class="detail-location">
                        <span>{{ item.detail }}</span>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="item self-address"
                    v-for="store of storeList"
                    :key="store.id"
                    :class="activeStore === store.id ? 'active' : ''"
                    @click="changeSelfAddress(store.id)"
                  >
                    <div class="main-name">
                      <img src="/assets/pc/images/pay/location.png" alt="" />
                      <span>{{ store.name }}</span>
                      <span>{{ store.phone }}</span>
                    </div>
                    <div class="main-location">
                      <div class="people-box">
                        <span>{{ store.name }}</span>
                        <span>{{ store.phone }}</span>
                      </div>
                      <div class="detail-location">
                        <span>{{ store.detailed_address }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div class="address-choose common-padding">
          <div class="common-title">
            <div class="common-red-quote transport">
              取货方式
              <div v-if="border === 0 && orderGroupInfo.priceGroup">
                <span>配送费用:</span>
                <span
                  class="red-transport"
                  v-if="orderGroupInfo.priceGroup.storePostage > 0"
                  >￥{{ orderGroupInfo.priceGroup.storePostage }}</span
                >
                <span v-else>免运费</span>
              </div>
            </div>
          </div>
          <div class="transport-type">
            <div @click="radioChange(0)" :class="border === 0 ? 'on' : ''">
              快递配送
            </div>
            <!-- <div @click="radioChange(1)" :class="border === 1 ? 'on' : ''">
              到店自提
            </div> -->
          </div>
          <div class="contact-people" v-if="border === 1">
            <div>
              <div class="title">
                <img src="/assets/pc/images/pay/contact.png" alt="" />
              </div>
              <input
                v-model="contacts"
                type="text"
                class="real-name"
                placeholder="请填写您的联系姓名"
              />
            </div>
            <div>
              <div class="title">
                <img src="/assets/pc/images/pay/contact-tel.png" alt="" />
              </div>
              <input
                v-model="contactsTel"
                type="text"
                class="real-name"
                placeholder="请填写您的联系电话"
              />
            </div>
          </div>
        </div>
        <div class="product-list common-padding">
          <div class="common-title">
            <div class="common-red-quote">商品信息</div>
            <div class="back-cart" @click="goBackCart">返回购物车</div>
          </div>
          <div class="product-box">
            <div class="item" v-for="item of shoppingCart" :key="item.id">
              <div class="img">
                <img :src="item.productInfo.image" />
              </div>
              <div class="name">{{ item.productInfo.store_name }}</div>
              <div class="num">x{{ item.cart_num }}</div>
              <div class="price">{{ item.truePrice }}</div>
            </div>
            <div class="tip-box">
              <div class="title">添加订单备注</div>
              <input
                v-model="remarks"
                type="text"
                class="remark-input"
                placeholder="在这里填入备注信息"
              />
            </div>
          </div>
        </div>
        <div
          class="drug-box common-padding"
          v-if="userInfo.certification_type !== 2"
        >
          <div class="common-title">
            <div class="common-red-quote">
              患者身份证或户口簿图片(共1张)
            </div>
          </div>
          <div class="phofo">
            <UploadPic @getPrescriptionImg="getPrescriptionImg"></UploadPic>
          </div>
        </div>
        <div class="warning-box">
          <div class="title">温馨提示</div>
          <p>
            因汇率是实时波动的，最终金额以实际付款为准！
          </p>
        </div>

        <div class="pay-container">
          <div class="pay-box">
            <div>
              &nbsp;&nbsp;&nbsp;税费：￥{{
                orderGroupInfo.priceGroup.taxesPrice
              }}
            </div>
            <p class="allMonkey">
              <span>提交订单应付总额：</span>
              <span class="money"
                >￥
                <span class="price-font">{{
                  totalPrice.toFixed(2)
                }}</span></span
              >
            </p>
            <div class="pay-list" v-if="userInfo.certification_type !== 1">
              <!-- <div
                class="item"
                :class="payType === 'weixin' ? 'active' : ''"
                @click="changePayType('weixin')"
              >
                <div class="left">
                  <img src="../../assets/pc/images/pay/weixin.png" alt="" />
                  微信支付
                </div>
                <div class="right">微信快捷支付</div>
              </div> -->
              <div
                class="item"
                :class="payType === 'alipay' ? 'active' : ''"
                @click="changePayType('alipay')"
              >
                <div class="left">
                  <img src="@/assets/pc/images/pay/alipay.png" alt="" />
                  支付宝支付
                </div>
                <div class="right">支付宝快捷支付</div>
              </div>
              <!-- <div
                class="item"
                :class="payType === 'yue' ? 'active' : ''"
                @click="changePayType('yue')"
              >
                <div class="left">
                  <img src="../../assets/pc/images/pay/pay.png" alt="" />
                  余额支付
                </div>
                <div class="right">可用余额: {{ userInfo.now_money }}</div>
              </div> -->
              <!-- <div
                class="item"
                :class="payType === 'offline' ? 'active' : ''"
                @click="changePayType('offline')"
              >
                <div class="left">
                  <img src="../../assets/pc/images/pay/offline.png" alt="" />
                  线下支付
                </div>
                <div class="right">线下方便支付</div>
              </div> -->
            </div>
            <div class="pay-btn" @click="commitOrder">
              <Button
                type="error"
                size="large"
                v-if="userInfo.certification_type !== 1"
                class="bg-btn"
              >
                支付订单
              </Button>
              <Button type="error" size="large" v-else class="bg-btn">
                提交审核
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="modal" width="600">
      <p slot="header">
        <Icon type="add"></Icon>
        <span>新增地址</span>
      </p>
      <div>
        <Form
          :model="formData"
          label-position="left"
          :label-width="100"
          :rules="ruleInline"
          ref="formDynamic"
        >
          <FormItem label="收件人" prop="real_name">
            <i-input v-model="formData.real_name" size="large"></i-input>
          </FormItem>
          <FormItem label="收件地区" prop="address">
            <div @click.stop="show2 = true">
              <i-input v-model="modelAdress" size="large"></i-input>
            </div>
            <CitySelect
              v-model="show2"
              :callback="result2"
              :items="district"
              provance=""
              city=""
              area=""
            ></CitySelect>
          </FormItem>
          <FormItem label="详细地址" prop="detail">
            <i-input v-model="formData.detail" size="large"></i-input>
          </FormItem>
          <FormItem label="手机号码" prop="phone">
            <i-input v-model="formData.phone" size="large"></i-input>
          </FormItem>
        </Form>
      </div>
      <div class="setAddress">
        <div class="title">
          设置为默认地址
        </div>
        <i-switch v-model="switch1" @on-change="changeSwitch" />
      </div>
      <div slot="footer">
        <Button @click="modal = false">取消</Button>
        <Button type="primary" @click="editAction">提交</Button>
      </div>
    </Modal>
    <div class="mask" v-if="maskShow">
      <div class="content">
        <div class="title" v-if="payType === 'weixin' || payType === 'alipay'">
          <img src="/assets/pc/images/pay/success.png" alt="" />
          <span class="success">付款二维码生成中</span>
        </div>
        <div class="title" v-else>
          <img src="/assets/pc/images/pay/loading.png" alt="" class="laoding" />
          <span class="success">订单处理中</span>
        </div>
        <div class="time">请稍等...</div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadPic from "@/components/pc/authenticate/UploadPic";
import StepNumber from "@/components/pc/commonTool/Steps/StepNumber";
import StepCommit from "@/components/pc/commonTool/Steps/StepCommit";
import { getAddressList, getUserInfo, postAddress } from "@api/user";
import { postOrderConfirm, createOrder, postOrderComputed } from "@api/order";
import { storeListApi } from "@api/store";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import District from "ydui-district/dist/jd_province_city_area_id";
import axios from "axios";
import BScroll from "better-scroll";
export default {
  name: "Order",
  components: {
    CitySelect,
    UploadPic,
    StepNumber,
    StepCommit
  },
  data() {
    return {
      goodsCheckList: [],
      checkAddress: {
        name: "未选择",
        address: "请选择地址"
      },
      remarks: "",
      shoppingCart: [], // 渲染所需的格式
      border: 0, // 0为快递配送
      system_store: {}, // 自提地址
      address: [],
      isDefault: 1, // 默认地址, 提交参数所需的地址ID
      pinkId: 0, // 拼团ID
      userInfo: {},
      payType: "alipay",
      orderGroupInfo: {},
      totalPrice: 0,
      contacts: "",
      contactsTel: "",
      activeStore: "",
      modal: false,
      formData: {
        real_name: "",
        address: {
          province: "",
          city: "",
          district: "",
          city_id: ""
        },
        phone: "",
        post_code: "",
        is_default: 0,
        detail: "",
        id: ""
      },
      ruleInline: {
        real_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        detail: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            type: "string",
            pattern: /^1[3|4|5|7|8][0-9]{9}$/,
            message: "手机号格式出错",
            trigger: "blur"
          }
        ]
      },
      show2: false,
      modelAdress: "选择收货地区",
      district: District,
      switch1: false,
      imageList: [], // 处方图片
      maskShow: false,
      storeList: [],
      recodeScrollWidth: ""
    };
  },
  created() {
    getUserInfo().then(res => {
      this.userInfo = res.data;
    });

    const cartId = this.$route.params.cardId;
    postOrderConfirm(cartId).then(res => {
      this.system_store = res.data.system_store;
      this.orderGroupInfo = res.data;
      this.shoppingCart = res.data.cartInfo;
      this.computedPrice();
    });

    if (this.$route.query.pinkid !== undefined) {
      // 获取拼团id
      this.pinkId = this.$route.query.pinkid;
    }
  },
  async mounted() {
    await this.getAddressInfo(); // 渲染收货地址
    await this.getStoreListApi(); // 渲染自提地址

    this.$refs.addressTab.style.width =
      this.$refs.addressTab.scrollWidth + "px";
    this.recodeScrollWidth = this.$refs.addressTab.scrollWidth;
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.wrapper, {
        scrollX: true,
        click: false,
        scrollY: false,
        eventPassthrough: "vertical"
      });
    });
  },
  methods: {
    radioChange(index) {
      this.border = index;
      this.computedPrice();
      // 当切换配送方式，需重新计算长度
      if (this.border === 1) {
        this.$refs.addressTab.style.width = 400 * this.storeList.length + "px";
        this.scroll.refresh();
      } else {
        this.$refs.addressTab.style.width = this.recodeScrollWidth + "px";
        this.scroll.refresh();
      }
    },
    changeSelfAddress(index) {
      this.activeStore = index;
    },
    async getAddressInfo() {
      // 获取收货地址
      const res = await getAddressList();
      this.address = res.data;
      this.address.forEach(item => {
        if (item.is_default === 1) {
          this.isDefault = item.id;
          this.changeAddress(item.id);
        }
      });
    },
    async getStoreListApi() {
      // 自提地址
      const res = await storeListApi();
      this.storeList = res.data.list;
      this.activeStore = res.data.list[0].id;
    },
    changeAddress(data) {
      // 更改收货地址
      this.isDefault = data;
      this.address.forEach(item => {
        if (item.id === data) {
          this.checkAddress.name = item.real_name;
          this.checkAddress.address = `${item.real_name} ${item.phone} ${
            item.province
          } ${item.city} ${item.district} ${item.detail}  ${
            item.is_default === 1 ? "[默认]" : ""
          }`;
        }
      });
    },
    changePayType(type) {
      // 更改付款方式
      this.payType = type;
    },
    computedPrice() {
      // 实时更新总价
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.isDefault,
        useIntegral: 0,
        couponId: 0,
        shipping_type: this.border + 1
      }).then(res => {
        this.totalPrice = res.data.result.pay_price;
      });
    },
    commitOrder() {
      // 提交订单
      if (this.imageList.length < 1 && this.userInfo.certification_type !== 2) {
        this.$Message.error("患者身份证或户口簿图片(共1张)");
        return;
      }

      // 如果是自提情况
      if (this.border === 1) {
        if (this.contacts === "" || this.contactsTel === "") {
          this.$Message.error("请填写联系人或联系人电话");
          return;
        }

        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          return this.$Message.error("请填写联系人电话");
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$Message.error("请填写您的真实姓名");
        }
      }

      const params = {
        real_name: this.contacts,
        phone: this.contactsTel,
        pinkId: this.pinkId,
        addressId: this.isDefault,
        payType: this.payType,
        productPriceList: [], // 暂时先不传信息
        mark: this.remarks,
        store_id: this.activeStore,
        shipping_type: this.border + 1, // 参数为配送的类型
        from: this.payType === "weixin" ? "weixinpc" : "weixinh5",
        certification_type: this.userInfo.certification_type,
        imageList: this.imageList
      };
      this.maskShow = true;
      createOrder(this.orderGroupInfo.orderKey, params)
        .then(res => {
          const OrderInfo = res.data;
          if (OrderInfo.status === "SUCCESS") {
            this.$router.replace({
              path: "/home/myOrder"
            });
          } else if (OrderInfo.status === "WECHAT_PC_PAY") {
            const img = res.data.result.results.payUrl;
            const orderId = res.data.result.results.orderNo;
            const method = "weixin";
            this.$router.push({
              name: "Pay",
              params: { img, orderId, method }
            });
          } else if (OrderInfo.status === "ALIPAY_PAY") {
            const img = res.data.result.jsConfig.results.payUrl;
            const orderId = res.data.result.orderId;
            const method = "zhifubao";
            this.$router.push({
              name: "Pay",
              params: { img, orderId, method }
            });
          }
          this.maskShow = false;
        })
        .catch(err => {
          this.$Message.error(err.msg);
        });
    },
    goAddAddress() {
      // 打开隐藏新增收货地址的面板
      this.modal = true;
    },
    editAction() {
      // 提交新增收货地址
      this.$refs.formDynamic.validate(valid => {
        if (valid) {
          postAddress(this.formData).then(res => {
            if (res.status === 200) {
              this.$Message.success("添加成功");
              this.modal = false;
              this.getAddressInfo();
            }
          });
        }
      });
    },
    result2(ret) {
      // 省市区选择
      this.modelAdress =
        ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.formData.address.province = ret.itemName1;
      this.formData.address.city = ret.itemName2;
      this.formData.address.city_id = ret.itemValue2;
      this.formData.address.district = ret.itemName3;
    },
    changeSwitch(status) {
      // 是否设置为默认地址
      if (status) {
        this.formData.is_default = 1;
      } else {
        this.formData.is_default = 0;
      }
    },
    getPrescriptionImg(list) {
      // 获取子组件传来的处方图片
      this.imageList = list;
    },
    goBackCart() {
      this.$router.push({
        path: "/shoppingCart"
      });
    },
    downloadFileClick() {
      const Url = "/自我保证声明书.pdf";
      axios
        .get(Url, {
          responseType: "blob" // 重要
        })
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          const fname = Url.slice(1);
          link.href = url;
          link.setAttribute("download", fname);
          document.body.appendChild(link);
          link.click();
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
.goods-list-container
  margin 50px auto 15px
  width 88%
  .confirm-order
    margin-bottom 30px
    display flex
    justify-content space-between
    .img
      width 190px
      height 35px
      img
        width 100%
        height 100%
  .address-form
    padding-bottom 20px
    .title-box
      .add-new-address
        color #2d8cf0
        cursor pointer
    .address-list
      .wrapper
        width 100%
        overflow hidden
        .content
          white-space: nowrap;
          .item
            width 240px
            height 150px
            border 1px solid #e3e3e3
            border-radius 4px
            padding 14px 14px 0
            cursor pointer
            display inline-block
            margin-right 20px
            &.active
              border 1px solid #ff4040
              position relative
              &::after
                content: ''
                display inline-block
                width 20px
                height 20px
                background-image url('../../assets/pc/images/pay/active.png')
                background-size 100% 100%
                position absolute
                right -1px
                bottom 0
                border-radius 0 0 4px 0
            .main-name
              display flex
              align-items center
              padding-bottom 12px
              border-bottom 1px dashed #e6e6e6
              img
                width 16px
                height 16px
                line-height 0
              span
                font-size 16px
                color #666
                margin-left 12px
                vertical-align bottom
              span:last-child
                font-size 15px
                transform translateY(0.5px)
              .default
                color #666
            .main-location
              margin-top 12px
              color #666
              font-size 14px
              line-height 24px
              .people-box
                span
                  margin-right 12px
              .province
                span
                  margin-right 5px
              .detail-location
                font-size 14px
                line-height 24px
          .self-address
            width 400px
            margin-right 25px
          &.self-list
            justify-content flex-start
  .address-choose
    .transport
      div
        color #999
        font-size 14px
        display inline-block
        margin-left 30px
        span:last-child
          margin-left 10px
        .red-transport
          color #ff4040
          font-weight 700
    .transport-type
      display flex
      margin-bottom 16px
      div
        height 38px
        width 120px
        text-align center
        line-height 38px
        border 1px solid #e6e6e6
        margin-right 13px
        border-radius 3px
        font-size 14px
        cursor pointer
        &.on
          border 1px solid #ff4040
          position relative
          &::after
            content: ''
            display inline-block
            width 16px
            height 16px
            background-image url('../../assets/pc/images/pay/active.png')
            background-size 100% 100%
            position absolute
            right -1px
            bottom 0
            border-radius 0 0 4px 0
    .contact-people
      >div
        display flex
        margin-bottom 10px
        .title
          width 25px
          height 25px
          margin-right 20px
          transform translateY(3px)
          img
            width 100%
            height 100%
        .real-name
          border 1px solid #f1f1f1
          border-radius 4px
          line-height 30px
          background #fafafa
          padding-left 5px
          &::-webkit-input-placeholder
            color #bbb
          &:-moz-placeholder
            color #bbb
          &:moz-placeholder
            color #bbb
          &:-ms-input-placeholder
            color #bbb
  .product-list
    .back-cart
      color #2d8cf0
      cursor pointer
    .product-box
      .item
        display flex
        align-items center
        background #fafafa
        border 1px solid #e3e3e3
        margin-left 20px
        padding 10px 0 10px 25px
        border-radius 3px
        font-size 14px
        margin-bottom 10px
        .img
          width 60px
          height 60px
          background #000
          margin-right 30px
          img
            width 100%
            height 100%
        .name
          width 600px
        .num
          width 200px
        .price
          flex 1
          text-align center
          font-weight 700
    .tip-box
      margin-left 20px
      margin-top 35px
      margin-bottom 20px
      .title
        font-size 14px
        margin-bottom 10px
      .remark-input
        border 1px solid #e3e3e3
        height 30px
        width 480px
        border-radius 3px
        padding-left 10px
  .drug-box
    .phofo
      margin-left 20px
    .down-box
      margin-left 60px
      color #999
      cursor pointer
      .down-icon
        color #5591ff
        font-size 22px
        transform translateY(3px)
        margin-right 5px
  .warning-box
    padding 20px 40px
    background #fff4f2
    border 1px solid #ffd8d2
    border-radius 4px
    color #ff4141
    .title
      font-size 14px
      font-weight 700
  .pay-container
    margin 15px
    display flex
    justify-content flex-end
    .pay-box
      font-size 18px
      font-weight bolder
      color #495060
      .pay-btn
        margin 15px 0px
        display flex
        justify-content flex-end
        .bg-btn
          font-size 16px
          background #ff4040
          width 100px
    .allMonkey
      text-align right
      .money
        font-size 16px
        color #ff4040
        .price-font
          font-size 30px
          margin-left -6px
    .pay-list
      margin 10px 0
      min-width 280px
      .item
        display flex
        justify-content space-between
        border 1px solid #dedede
        font-size 14px
        font-weight normal
        padding 5px
        margin-bottom 10px
        cursor pointer
        &.active
          border 1px solid #ff7a7a
        .left
        .right
          width 50%
          text-align center
        .left
          border-right 1px solid #eee
          img
            width 18px
            height 18px
            position relative
            top 4px
        .right
          color #9b9b9b

.common-padding
  padding 20px 20px 10px 40px
  border 1px solid #e3e3e3
  border-radius 4px
  background #fff
  margin-bottom 30px
.common-title
  display flex
  justify-content space-between
  font-size 16px
.common-red-quote
  color #333
  margin-left 15px
  margin-bottom 25px
  &:before
    content:''
    display inline-block
    width 3px
    height 20px
    background #ff4040
    transform translateX(-15px) translateY(4px)

.mask
  position fixed
  top: 0
  background rgba(0, 0, 0, .5)
  left 0
  right 0
  bottom 0
  display flex
  align-items center
  justify-content center
  z-index 999
  .content
    width 300px
    height 150px
    background #fff
    padding 30px
    border-radius 8px
    .title
      text-align center
      .laoding
        animation:turn 2s linear infinite
      img
        width 24px
        height 24px
        display inline-block
        position relative
        top 6px
      .success
        font-size 18px
        margin-left 5px
  .time
    margin-top 25px
    text-align center
    font-size 14px

@keyframes turn
  0%
    -webkit-transform rotate(0deg)
  25%
    -webkit-transform rotate(90deg)
  50%
    -webkit-transform rotate(180deg)
  75%
    -webkit-transform rotate(270deg)
  100%
    -webkit-transform rotate(360deg)
</style>
<style scoped>
/* .goods-list-container /deep/ .ivu-table-cell img{
  width: 100%
} */
</style>
